// Official NC DIT logo — per ~/.claude/CLAUDE.md DIT style guide
export const DIT_LOGO_URL =
  "https://files.nc.gov/dit/dit-logo_0.png?VersionId=hXzat98jbejrN24AhcEkTkX4mhZaJBAO";

export const DIT_LOGO_ALT = "NC Department of Information Technology";
